(() => {
  const hosts = document.querySelectorAll("[data-chn-host]");
  hosts.forEach((host) => {
    const iframe = host.querySelector("[data-chn-frame]");
    const loading = host.querySelector("[data-chn-loading]");
    if (!(iframe instanceof HTMLIFrameElement)) return;

    let designerOrigin;
    try {
      designerOrigin = new URL(iframe.src).origin;
    } catch {
      return;
    }

    iframe.addEventListener("load", () => {
      if (loading) loading.hidden = true;
      iframe.classList.add("is-ready");
    });

    window.addEventListener("message", async (event) => {
      if (event.origin !== designerOrigin || event.source !== iframe.contentWindow) return;
      const data = event.data || {};

      if (data.type === "CHN_DESIGNER_HEIGHT") {
        const height = Math.max(700, Math.min(20000, Number(data.height) || 0));
        iframe.style.height = `${height}px`;
        return;
      }

      if (data.type !== "CHN_ADD_TO_CART") return;
      const requestId = typeof data.requestId === "string" ? data.requestId : "";
      const cartLine = data.cartLine;
      const validLine = cartLine
        && /^\d+$/.test(String(cartLine.id))
        && cartLine.quantity === 1
        && cartLine.properties
        && typeof cartLine.properties === "object";
      if (!requestId || !validLine) return;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items: [cartLine] })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || result.message || "Shopify could not add this sign.");
        }
        iframe.contentWindow.postMessage(
          { type: "CHN_CART_RESULT", requestId, ok: true },
          designerOrigin
        );
        window.setTimeout(() => {
          window.location.assign(`${window.Shopify.routes.root}cart`);
        }, 2500);
      } catch (error) {
        iframe.contentWindow.postMessage(
          {
            type: "CHN_CART_RESULT",
            requestId,
            ok: false,
            message: error instanceof Error
              ? error.message
              : "Shopify could not add this sign. Please try again."
          },
          designerOrigin
        );
      }
    });
  });
})();
